import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F6F3]">
      {/* Simple top bar */}
      <header className="bg-white border-b border-stone-100 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/">
            <img
              src="https://storage.readdy-site.link/project_files/1b4b5470-43ee-4e4c-a03f-80bf782ac886/295ea2cc-8770-43e6-ae89-4a5f4095a2e1_PAWZLY-7.png?v=947d967eac3d6db96af148317019d39e"
              alt="Pawzly Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-stone-500 hover:text-stone-800 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="bg-white rounded-3xl p-8 md:p-14 border border-stone-100">
          <div className="mb-10">
            <h1 className="text-4xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
              Terms of Service
            </h1>
            <p className="text-stone-400 text-sm">Last updated: April 3, 2026</p>
          </div>

          <div className="prose prose-stone max-w-none space-y-10 text-stone-600 text-sm leading-relaxed">

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">1. Agreement to Terms</h2>
              <p>
                By accessing or using the Pawzly website and purchasing our products, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">2. Products and Orders</h2>
              <p className="mb-3">
                All product descriptions, images, and pricing are subject to change without notice. We reserve the right to limit quantities, refuse orders, or cancel orders at our discretion.
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Orders are confirmed once you receive an order confirmation email.</li>
                <li>We reserve the right to cancel any order due to pricing errors, stock issues, or suspected fraud.</li>
                <li>Product colors may vary slightly from images shown on screen due to monitor settings.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">3. Pricing and Payment</h2>
              <p className="mb-3">
                All prices are listed in US Dollars (USD) and are subject to change without notice. Applicable taxes will be calculated and added at checkout based on your shipping address.
              </p>
              <p>
                Payment is processed securely through Shopify Payments. We accept major credit cards and other payment methods as displayed at checkout. By submitting your payment information, you authorize us to charge the total amount shown at checkout.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">4. Shipping and Delivery</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>We offer free shipping on orders over $50 within the contiguous United States.</li>
                <li>Estimated delivery times are provided at checkout and are not guaranteed.</li>
                <li>We are not responsible for delays caused by shipping carriers, customs, or circumstances beyond our control.</li>
                <li>Risk of loss and title for products pass to you upon delivery to the carrier.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">5. Returns and Refunds</h2>
              <p className="mb-3">
                We want you to be completely satisfied with your purchase. If you are not happy with your order, we offer a 30-day return policy from the date of delivery.
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Items must be unused, in their original packaging, and in the same condition as received.</li>
                <li>To initiate a return, contact us at hello@pawzly.com with your order number.</li>
                <li>Return shipping costs are the responsibility of the customer unless the item is defective or we made an error.</li>
                <li>Refunds will be processed to the original payment method within 5–10 business days of receiving the returned item.</li>
                <li>Sale items and opened refill bags are final sale and cannot be returned.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">6. Intellectual Property</h2>
              <p>
                All content on this website — including text, images, logos, graphics, and product designs — is the property of Pawzly and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">7. Disclaimer of Warranties</h2>
              <p>
                Our products are provided "as is." While we stand behind the quality of our products, we make no warranties, express or implied, regarding fitness for a particular purpose beyond what is described in our product listings. Our liability is limited to the purchase price of the product in question.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">8. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Pawzly shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or products. Our total liability to you for any claim shall not exceed the amount you paid for the product giving rise to the claim.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">9. Governing Law</h2>
              <p>
                These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law principles. Any disputes arising under these terms shall be resolved through binding arbitration or in the courts of competent jurisdiction.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">10. Changes to Terms</h2>
              <p>
                We reserve the right to update these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our website after changes are posted constitutes your acceptance of the updated terms.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-stone-800 mb-3">11. Contact Us</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 p-5 bg-[#F8F6F3] rounded-xl border border-stone-100">
                <p className="font-semibold text-stone-800">Pawzly</p>
                <p className="mt-1">Email: <a href="mailto:hello@pawzly.com" className="text-[#C4956A] hover:underline">hello@pawzly.com</a></p>
              </div>
            </section>

          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/privacy"
            className="text-[#8A9B85] hover:text-stone-800 text-sm transition-colors cursor-pointer underline underline-offset-4"
          >
            View Privacy Policy
          </Link>
        </div>
      </main>
    </div>
  );
}
